import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import PriceVatDisclaimer from 'common/PriceVatDisclaimer';
import { plansData, formatEur } from '../data';

const planAccent = {
  esencial: '#5C6BC0',
  desarrollo: '#7B1FA2',
  premium: '#00897B',
};

const InversionSection = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 600 }}
          gutterBottom
          color="primary"
          align="center"
        >
          4. Planes de inversión
        </Typography>
        <Typography variant="h4" fontWeight={700} align="center" gutterBottom>
          De 120 € a 350 € / mes
        </Typography>
        <Typography variant="body1" color="textSecondary" align="center" sx={{ maxWidth: 720, mx: 'auto' }}>
          Tres escalones de pauta publicitaria para adaptarse a los objetivos y alcance requeridos por Prudence.
          Tarifas netas mensuales en euros.
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {plansData.map((plan) => {
          const accent = planAccent[plan.id] || theme.palette.primary.main;

          return (
            <Grid item xs={12} md={4} key={plan.id} data-aos="fade-up">
              <Box
                component={Card}
                height="100%"
                display="flex"
                flexDirection="column"
                variant="outlined"
                sx={{
                  borderTop: 4,
                  borderColor: accent,
                  transition: 'all .2s ease-in-out',
                  boxShadow: plan.highlight ? 6 : 1,
                  transform: plan.highlight ? 'scale(1.02)' : 'none',
                  '&:hover': { boxShadow: 8 },
                }}
              >
                <Box
                  py={2}
                  px={2}
                  sx={{
                    bgcolor: accent,
                    color: theme.palette.common.white,
                    textAlign: 'center',
                  }}
                >
                  <Typography variant="overline" fontWeight={700} display="block">
                    {plan.tag}
                  </Typography>
                  <Typography variant="h3" fontWeight={900}>
                    {formatEur(plan.monthlyEur)}
                  </Typography>
                  <Typography variant="caption" display="block" sx={{ opacity: 0.95 }}>
                    / mes · EUR neto
                  </Typography>
                </Box>
                <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                  <Typography variant="h6" fontWeight={700} gutterBottom>
                    {plan.title}
                  </Typography>
                  <List dense disablePadding sx={{ flex: 1, mb: 2 }}>
                    {plan.features.map((feature, idx) => (
                      <ListItem key={idx} disableGutters alignItems="flex-start">
                        <ListItemIcon sx={{ minWidth: 32, mt: 0.25 }}>
                          <CheckCircleIcon color="primary" fontSize="small" />
                        </ListItemIcon>
                        <ListItemText
                          primary={feature}
                          primaryTypographyProps={{ variant: 'body2' }}
                        />
                      </ListItem>
                    ))}
                  </List>
                  <Typography variant="caption" color="textSecondary" sx={{ mt: 'auto', display: 'block' }}>
                    {plan.idealFor}
                  </Typography>
                </CardContent>
              </Box>
            </Grid>
          );
        })}
      </Grid>

      <Box mt={4}>
        <Box
          component={Card}
          sx={{
            bgcolor: theme.palette.grey[100],
            borderLeft: 4,
            borderColor: theme.palette.primary.main,
          }}
        >
          <CardContent>
            <Typography variant="subtitle2" color="primary" fontWeight={700} gutterBottom>
              Nota fiscal y operativa
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Los montos expresados representan la tarifa neta del servicio y <strong>no incluyen IVA</strong>.
              Las condiciones de producción técnica audiovisual y editorial corren por cuenta de TNO Network,
              garantizando la reposición por fuerza mayor en caso de contingencias de infraestructura.
            </Typography>
          </CardContent>
        </Box>
      </Box>

      <PriceVatDisclaimer />
    </Box>
  );
};

export default InversionSection;
